import picture from 'assets/image/snail-looking-for.png'

import './style.scss'

import { CONSTS } from 'config/objectConst'
import { typo } from 'shared/styles'

import css from './NoSearchResult.module.scss'

export function NoSearchResult({
	lead
}: {
	lead: string
}) {
	return (
		<article className={css.root}>
			<span className='h-2'>Ooops… Nothing was found!</span>
			<img
				alt={`${CONSTS.PROJECT_NAME} found nothing 🙁`}
				className={css.pic}
				height={312}
				src={picture}
				width={312}
			/>
			<p className={`${typo.mediumBody} ${css.lead}`}>{lead}</p>
		</article>
	)
}
